import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const SettingsIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0108 16.5041C14.4962 16.5041 16.5109 14.4893 16.5109 12.004C16.5109 9.51867 14.4962 7.50391 12.0108 7.50391C9.5255 7.50391 7.51074 9.51867 7.51074 12.004C7.51074 14.4893 9.5255 16.5041 12.0108 16.5041Z"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2333 6.10798C17.4708 6.32673 17.6958 6.55174 17.9083 6.78299L20.4677 7.14863C20.8848 7.87286 21.2062 8.64808 21.424 9.45492L19.8677 11.5268C19.8677 11.5268 19.8959 12.1644 19.8677 12.4831L21.424 14.555C21.2072 15.3622 20.8857 16.1376 20.4677 16.8613L17.9083 17.227C17.9083 17.227 17.4677 17.6863 17.2333 17.902L16.8677 20.4614C16.1434 20.8784 15.3682 21.1998 14.5614 21.4177L12.4895 19.8614C12.1713 19.8895 11.8513 19.8895 11.5332 19.8614L9.46127 21.4177C8.65409 21.2009 7.87874 20.8794 7.15497 20.4614L6.78934 17.902C6.55809 17.6832 6.33308 17.4582 6.11433 17.227L3.5549 16.8613C3.13788 16.1371 2.81644 15.3619 2.59863 14.555L4.15491 12.4831C4.15491 12.4831 4.12679 11.8456 4.15491 11.5268L2.59863 9.45492C2.81544 8.64774 3.13692 7.87239 3.5549 7.14863L6.11433 6.78299C6.33308 6.55174 6.55809 6.32673 6.78934 6.10798L7.15497 3.54855C7.87921 3.13153 8.65443 2.8101 9.46127 2.59229L11.5332 4.14857C11.8513 4.12043 12.1713 4.12043 12.4895 4.14857L14.5614 2.59229C15.3686 2.80909 16.1439 3.13057 16.8677 3.54855L17.2333 6.10798Z"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(SettingsIcon);
